/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Limittitle1Inputs */

const zh_learn_limittitle1 = /** @type {(inputs: Learn_Limittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已达到完成次数上限`)
};

const en_learn_limittitle1 = /** @type {(inputs: Learn_Limittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completion limit reached`)
};

const es_learn_limittitle1 = /** @type {(inputs: Learn_Limittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alcanzó el límite de completados`)
};

/**
* | output |
* | --- |
* | "Completion limit reached" |
*
* @param {Learn_Limittitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_limittitle1 = /** @type {((inputs?: Learn_Limittitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Limittitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_limittitle1(inputs)
	if (locale === "en") return en_learn_limittitle1(inputs)
	return es_learn_limittitle1(inputs)
});
export { learn_limittitle1 as "learn_limitTitle" }